import React from "react";
import BodyPage from "../components/body/BodyPage";

const HomePage = () => {
  return <BodyPage />;
};

export default HomePage;
